import { render, staticRenderFns } from "./configmap.vue?vue&type=template&id=be11f872&scoped=true&"
import script from "./configmap.vue?vue&type=script&lang=js&"
export * from "./configmap.vue?vue&type=script&lang=js&"
import style0 from "./configmap.vue?vue&type=style&index=0&id=be11f872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be11f872",
  null
  
)

export default component.exports